import { z } from 'zod'
import { AsyncFn } from '../../common'
import { ForCompany } from '../Company/Company'

export const DISPLAY_ID_ENTITY_TYPES = ['INVOICE', 'JOB', 'ESTIMATE', 'PRICEBOOK_VERSION', 'ACCOUNT'] as const

export const DisplayIdGeneratorRequestSchema = z.object({
  entityType: z.enum(DISPLAY_ID_ENTITY_TYPES),
})

export type DisplayIdGeneratorRequest = z.infer<typeof DisplayIdGeneratorRequestSchema>

export type DisplayIdGenerator = AsyncFn<ForCompany<DisplayIdGeneratorRequest>, number>

const DisplayIdUpserterRequestSchema = z.object({
  entityType: z.enum(DISPLAY_ID_ENTITY_TYPES),
  counter: z.number(),
})

export type DisplayIdUpserterRequest = z.infer<typeof DisplayIdUpserterRequestSchema>

export type DisplayIdUpserter = AsyncFn<ForCompany<DisplayIdUpserterRequest>, void>
